import { render, staticRenderFns } from "./PurchasesReports.vue?vue&type=template&id=29e34380&"
import script from "./PurchasesReports.vue?vue&type=script&lang=js&"
export * from "./PurchasesReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports